export default "__VITE_ASSET__813ba961__"